const mutations = {
  GET_EMPRESA(state) {
    return state.empresa;
  },

  SET_EMPRESA(state, empresa) {
    state.empresa = empresa;
  },
};

export default mutations;
